import * as React from 'react';
import { Skeleton } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const CCCLineItemFailed = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "ccc-line-item-failed"
    }, /*#__PURE__*/ React.createElement(Skeleton, {
        height: "100%",
        width: "100%",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "100%",
        rx: "5",
        fill: "currentColor"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "ccc-line-item-failed__text"
    }, getLabel('account.ccc.product.failed')));
};

export { CCCLineItemFailed as default };
//# sourceMappingURL=CCCLineItemFailed.js.map
